export const MOON_DEFAULTS = {
  diameter: 100,
  shadowColor: "rgb(51, 51, 51)",
  lightColor: "rgb(230, 230, 230)",
  earthshine: 0.1,
  blur: 3
}